// extracted by mini-css-extract-plugin
export default {"tools":"tools_tools__gIXxx","item":"tools_item__hhooE","noPaddings":"tools_noPaddings__EpH6H"};